import { gql } from '@apollo/client';

export const CAN_USE_SOCIAL_MEDIA_INTEGRATION = gql`
  query CanUseSocialMediaIntegration(
    $input: CanUseSocialMediaIntegrationInput!
  ) {
    canUseSocialMediaIntegration(input: $input) {
      canUseNewIntegration
    }
  }
`;

export const CAN_USE_CB_SOCIAL_MEDIA_FLOW = gql`
  query CanUseCbSocialMediaFlow($input: CanUseSocialMediaIntegrationInput!) {
    canUseCbSocialMediaFlow(input: $input)
  }
`;

export const GET_CONNECTED_SOCIAL_MEDIA_POSTS = gql`
  query GetConnectedSocialMediaPosts(
    $input: GetConnectedSocialMediaPostsInput!
  ) {
    getConnectedSocialMediaPosts(input: $input) {
      entities {
        id
        caption
        thumbnailUrl
        permalink
        timestamp
        mediaProductType
        stats {
          likes
          comments
          views
          reach
          saves
          shares
        }
      }
      nextCursor
    }
  }
`;
